import router from "@/router";
import customFetch from "@/services/fetch";
import {useToast} from "vue-toastification";

const toast = useToast();

const actions = {
    async create({ state, dispatch }, { resourceData, endpoint, afterAction = null }) {
        try {
            endpoint = endpoint.replace(/^\/|\/$/g, '');
            const organizationId = router.currentRoute.value.params.organizationId || 1;

            const payload = {
                ...resourceData,
                organization_id: organizationId
            };

            const response = await customFetch(`/${endpoint}`, {
                body: JSON.stringify(payload)
            });

            if (afterAction) {
                dispatch(afterAction, null, { root: true });
            }

            return response;
        } catch (error) {
            toast.error(error.message)
            return false;
        }
    },
    async update({ state }, { resourceData, endpoint }) {
        try {
            endpoint = endpoint.replace(/^\/|\/$/g, '');
            const organizationId = router.currentRoute.value.params.organizationId || 1;

            const payload = {
                ...resourceData,
                organization_id: organizationId
            };

            return await customFetch(`/${endpoint}/${resourceData.id}`, {
                body: JSON.stringify(payload)
            });
        } catch (error) {
            toast.error(error.message)
        }
    },
    async delete({ state }, { resourceId, endpoint }) {
        try {
            endpoint = endpoint.replace(/^\/|\/$/g, '');
            await customFetch(`/${endpoint}/${resourceId}`);
        } catch (error) {
            toast.error(error.message)
        }
    },
    async get({ commit }, { endpoint, afterMutation = null, resourceData = {} }) {
        try {
            endpoint = endpoint.replace(/^\/|\/$/g, '');
            const organizationId = router.currentRoute.value.params.organizationId || 1;

            const payload = {
                ...resourceData,
                organization_id: organizationId
            };

            const response = await customFetch(`/${endpoint}/${resourceData.id}`, {
                body: JSON.stringify(payload)
            })

            if (response.data && afterMutation) {
                commit(afterMutation, response.data, { root: true });
            }

            return response.data;
        } catch (error) {
            toast.error(error.message)
        }
    },
    async fetchInitialData({ commit }, { endpoint, afterMutation = null, resourceData = {} }) {
        try {
            endpoint = endpoint.replace(/^\/|\/$/g, '');
            const organizationId = router.currentRoute.value.params.organizationId || 1;

            const payload = {
                ...resourceData,
                organization_id: organizationId
            };

            const response = await customFetch(`/${endpoint}`, {
                body: JSON.stringify(payload)
            })

            // console.log(response.data)
            if (response.data && afterMutation) {
                commit(afterMutation, response.data, { root: true });
            }

            return response.data;
        } catch (error) {
            toast.error(error.message)
        }
    },
}

export default {
    namespaced: true,
    actions,
};
